"use client"
import styled from "@emotion/styled"
import { ElementType } from "react"
import { Container, TitleTextLink } from "ui"

const StyledDiv = styled.div`
  padding-top: 32px;
  padding-bottom: 32px;
  ${(props) => props.theme.breakpoints.up("md")} {
    padding-top: 60px;
    padding-bottom: 60px;
  }
`

type Props = {
  data: any
  children: React.ReactNode
  titleTag?: ElementType<any>
}

function TitleWithButton({ data, children, titleTag = "h1" }: Props) {
  return (
    <Container>
      <StyledDiv>
        {children}
        <TitleTextLink data={data} titleTag={titleTag} />
      </StyledDiv>
    </Container>
  )
}
export default TitleWithButton
